// Combo buscable de CUENTA CONTABLE (plan de cuentas). Reemplaza a los <select>
// de cuentas: se escribe para filtrar por código/nombre (sin tildes). Se
// autoabastece del plan (RPC cont_plan) y por defecto ofrece SOLO cuentas
// IMPUTABLES (es_movimiento) y activas — que son a las que se contabiliza.
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';
import { BuscadorCombo } from './BuscadorCombo';

export interface CuentaOpt {
  id: string; codigo: string; nombre: string; tipo: string; es_movimiento: boolean; es_activo: boolean;
}

const CONT = { headers: { 'Content-Profile': 'contabilidad', 'Accept-Profile': 'contabilidad' } };
const cargarPlan = async (): Promise<CuentaOpt[]> =>
  (await apiClient.post('/rpc/cont_plan', {}, CONT)).data as CuentaOpt[];

export function BuscadorCuenta({
  value, onChange, disabled, compact, allowClear, placeholder = 'Buscar cuenta…', soloMovimiento = true, tipos,
}: {
  value: string; onChange: (id: string) => void;
  disabled?: boolean; compact?: boolean; allowClear?: boolean; placeholder?: string; soloMovimiento?: boolean;
  // Filtro adicional por tipo de cuenta (p.ej. ['gasto','costo']); undefined = todos los tipos.
  tipos?: string[];
}) {
  const { data: plan = [], isLoading } = useQuery<CuentaOpt[]>({
    queryKey: ['cont-plan-buscador'], queryFn: cargarPlan, staleTime: 5 * 60 * 1000,
  });
  const items = useMemo(
    () => plan.filter((c) => c.es_activo
      && (!soloMovimiento || c.es_movimiento)
      && (!tipos || tipos.includes(c.tipo))),
    [plan, soloMovimiento, tipos],
  );
  return (
    <BuscadorCombo items={items} value={value} onChange={onChange}
      placeholder={placeholder} disabled={disabled} compact={compact} allowClear={allowClear} loading={isLoading} />
  );
}
